module.exports = __webpack_public_path__ + "static/media/8_sharing.3bf30b28.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/8_sharing.mp4
// module id = 325
// module chunks = 0